import { jsx as f } from "react/jsx-runtime";
import { createContext as p, useContext as m } from "react";
import { Address as l } from "./icons/Address.js";
import { Advice as a } from "./icons/Advice.js";
import { Archive as n } from "./icons/Archive.js";
import { ArrowDown as c } from "./icons/ArrowDown.js";
import { ArrowLeft as s } from "./icons/ArrowLeft.js";
import { ArrowRight as d } from "./icons/ArrowRight.js";
import { ArrowUp as h } from "./icons/ArrowUp.js";
import { Award as w } from "./icons/Award.js";
import { Battery as u } from "./icons/Battery.js";
import { CalBook as C } from "./icons/CalBook.js";
import { Cal as g } from "./icons/Cal.js";
import { CaretArrowDown as v } from "./icons/CaretArrowDown.js";
import { CaretArrowLeft as A } from "./icons/CaretArrowLeft.js";
import { CaretArrowRight as y } from "./icons/CaretArrowRight.js";
import { CaretArrowUp as S } from "./icons/CaretArrowUp.js";
import { ChartFilled as b } from "./icons/ChartFilled.js";
import { Chart as H } from "./icons/Chart.js";
import { CheckCircle as P } from "./icons/CheckCircle.js";
import { Check as E } from "./icons/Check.js";
import { ChevronDown as k } from "./icons/ChevronDown.js";
import { ChevronLeftSmallFirst as F } from "./icons/ChevronLeftSmallFirst.js";
import { ChevronLeftSmall as I } from "./icons/ChevronLeftSmall.js";
import { ChevronLeft as L } from "./icons/ChevronLeft.js";
import { ChevronRightSmallLast as M } from "./icons/ChevronRightSmallLast.js";
import { ChevronRightSmall as D } from "./icons/ChevronRightSmall.js";
import { ChevronRight as W } from "./icons/ChevronRight.js";
import { ChevronUp as x } from "./icons/ChevronUp.js";
import { CloseCircle as R } from "./icons/CloseCircle.js";
import { Cross as U } from "./icons/Cross.js";
import { Doc as T } from "./icons/Doc.js";
import { Dollar as q } from "./icons/Dollar.js";
import { Download as B } from "./icons/Download.js";
import { EcoHome as G } from "./icons/EcoHome.js";
import { Eco as j } from "./icons/Eco.js";
import { Edit as N } from "./icons/Edit.js";
import { ElectricCar as O } from "./icons/ElectricCar.js";
import { ElectricHome as z } from "./icons/ElectricHome.js";
import { Electricity as J } from "./icons/Electricity.js";
import { EnergyAdvice as K } from "./icons/EnergyAdvice.js";
import { Equals as Q } from "./icons/Equals.js";
import { Euro as V } from "./icons/Euro.js";
import { Gas as X } from "./icons/Gas.js";
import { GlobeAddress as Y } from "./icons/GlobeAddress.js";
import { HelpFilled as Z } from "./icons/HelpFilled.js";
import { Help as _ } from "./icons/Help.js";
import { Hide as $ } from "./icons/Hide.js";
import { HomeFilled as rr } from "./icons/HomeFilled.js";
import { Home as or } from "./icons/Home.js";
import { HydroPower as mr } from "./icons/HydroPower.js";
import { Info as tr } from "./icons/Info.js";
import { Link as er } from "./icons/Link.js";
import { Logo as ir } from "./icons/Logo.js";
import { MailOpen as fr } from "./icons/MailOpen.js";
import { Mail as pr } from "./icons/Mail.js";
import { Menu as lr } from "./icons/Menu.js";
import { MessageFilled as ar } from "./icons/MessageFilled.js";
import { Message as nr } from "./icons/Message.js";
import { Minus as cr } from "./icons/Minus.js";
import { Mobile as sr } from "./icons/Mobile.js";
import { NewWindow as dr } from "./icons/NewWindow.js";
import { PaymentCardFilled as hr } from "./icons/PaymentCardFilled.js";
import { PaymentCard as wr } from "./icons/PaymentCard.js";
import { Phone as ur } from "./icons/Phone.js";
import { Plus as Cr } from "./icons/Plus.js";
import { Pound as gr } from "./icons/Pound.js";
import { Pricing as vr } from "./icons/Pricing.js";
import { Search as Ar } from "./icons/Search.js";
import { Security as yr } from "./icons/Security.js";
import { Show as Sr } from "./icons/Show.js";
import { SmartHome as br } from "./icons/SmartHome.js";
import { SmartMeter as Hr } from "./icons/SmartMeter.js";
import { Solar as Pr } from "./icons/Solar.js";
import { StarFilled as Er } from "./icons/StarFilled.js";
import { Star as kr } from "./icons/Star.js";
import { Sun as Fr } from "./icons/Sun.js";
import { Torch as Ir } from "./icons/Torch.js";
import { Trees as Lr } from "./icons/Trees.js";
import { Tune as Mr } from "./icons/Tune.js";
import { UserFilled as Dr } from "./icons/UserFilled.js";
import { User as Wr } from "./icons/User.js";
import { Wallet as xr } from "./icons/Wallet.js";
import { WarmHome as Rr } from "./icons/WarmHome.js";
import { Warning as Ur } from "./icons/Warning.js";
import { WebAddress as Tr } from "./icons/WebAddress.js";
import { WindPower as qr } from "./icons/WindPower.js";
const t = {
  address: l,
  advice: a,
  archive: n,
  "arrow-down": c,
  "arrow-left": s,
  "arrow-right": d,
  "arrow-up": h,
  award: w,
  battery: u,
  "cal-book": C,
  cal: g,
  "caret-arrow-down": v,
  "caret-arrow-left": A,
  "caret-arrow-right": y,
  "caret-arrow-up": S,
  "chart-filled": b,
  chart: H,
  "check-circle": P,
  check: E,
  "chevron-down": k,
  "chevron-left-small-first": F,
  "chevron-left-small": I,
  "chevron-left": L,
  "chevron-right-small-last": M,
  "chevron-right-small": D,
  "chevron-right": W,
  "chevron-up": x,
  "close-circle": R,
  cross: U,
  doc: T,
  dollar: q,
  download: B,
  "eco-home": G,
  eco: j,
  edit: N,
  "electric-car": O,
  "electric-home": z,
  electricity: J,
  "energy-advice": K,
  equals: Q,
  euro: V,
  gas: X,
  "globe-address": Y,
  "help-filled": Z,
  help: _,
  hide: $,
  "home-filled": rr,
  home: or,
  "hydro-power": mr,
  info: tr,
  link: er,
  logo: ir,
  "mail-open": fr,
  mail: pr,
  menu: lr,
  "message-filled": ar,
  message: nr,
  minus: cr,
  mobile: sr,
  "new-window": dr,
  "payment-card-filled": hr,
  "payment-card": wr,
  phone: ur,
  plus: Cr,
  pound: gr,
  pricing: vr,
  search: Ar,
  security: yr,
  show: Sr,
  "smart-home": br,
  "smart-meter": Hr,
  solar: Pr,
  "star-filled": Er,
  star: kr,
  sun: Fr,
  torch: Ir,
  trees: Lr,
  tune: Mr,
  "user-filled": Dr,
  user: Wr,
  wallet: xr,
  "warm-home": Rr,
  warning: Ur,
  "web-address": Tr,
  "wind-power": qr
}, r = p(null);
function Am() {
  return m(r) || t;
}
function ym({
  children: o,
  icons: e = {}
}) {
  const i = {
    ...m(r) || t,
    ...e
  };
  return /* @__PURE__ */ f(r.Provider, { value: i, children: o });
}
export {
  ym as IconsProvider,
  t as defaultIcons,
  Am as useIcons
};
